import firebase from 'firebase/app';
import 'firebase/messaging';
import {firebaseConfig} from "config/enviroments";

firebase.initializeApp(firebaseConfig);

export const messaging = firebase.messaging();